<style src="./EditItem.scss" lang="scss" scoped></style>
<template>
  <section class="edit-item">
    <section class="item-description">
      <div class="top-row">
        <span class="lab">{{ itemDetails.lab }}</span>
        <span class="code-prod">{{ itemDetails.codProd }}</span>
      </div>

      <div class="item-name">
        <span class="comercial-name">{{ itemDetails.comercialName }}</span>
        <span class="pativo">{{ itemDetails.pativo }}</span>
      </div>

      <div class="item-costs">
        <div class="field code">
          <span class="title">RMS</span>
          <span class="value">{{ itemDetails.rmsCode }}</span>
        </div>

        <div class="field code">
          <span class="title">GGREM</span>
          <span class="value">{{ itemDetails.ggremCode }}</span>
        </div>

        <div class="field factor">
          <span class="title">FATOR</span>
          <span class="value">{{ itemDetails.factor }}</span>
        </div>

        <div class="field cost">
          <span class="title">CUSTO</span>
          <span class="value">{{ itemDetails.cost }}</span>
        </div>
      </div>
    </section>

    <section class="form-field">
      <div class="col-12">
        <label class="checkbox-label">
          <span class="label">Está suspenso</span>

          <input
            class="checkbox-input"
            type="checkbox"
            v-model="form.isSuspended">
        </label>
      </div>
      <div class="col-12">
        <label class="checkbox-label">
          <span class="label">Escolha preferível</span>

          <input
            class="checkbox-input"
            type="checkbox"
            v-model="form.isPreferred">
        </label>
      </div>

      <div class="row">
        <textbox
          class="col-6"
          label="Código RMS"
          placeholder="Ex.: 1091700990029"
          v-model="form.rmsCode" />
        <textbox
          class="col-6"
          label="Código GGREM"
          placeholder="Ex.: 525115120029506"
          v-model="form.ggremCode" />
        <textbox
          class="col-6"
          label="Código Fornecedor"
          placeholder="Ex.: 2645872"
          v-model="form.supplierCode" />
      </div>

      <form @submit.prevent="saveEdition" class="row">
        <button-submit
          class="col-5"
          label="Atualizar Produto"
          :state="commands.submitState"
          :icon-save="commands.saveIcon"/>
      </form>
    </section>
  </section>
</template>

<script>
import { IconSave } from '@/components/primitives/icons'
import { ButtonSubmit, Textbox } from '@/components/primitives'

export default {
  name: 'EditItem',
  components: {
    ButtonSubmit,
    Textbox
  },
  props: {
    itemDetails: null,
    itemIdx: null
  },
  data () {
    return {
      form: {
        isSuspended: false,
        isPreferred: false,
        rmsCode: '',
        ggremCode: '',
        supplierCode: ''
      },
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      }
    }
  },
  watch: {
    itemDetails: {
      handler () {
        this.form.isSuspended = this.itemDetails.isSuspended
        this.form.isPreferred = !!this.itemDetails.isPreferred
        this.form.rmsCode = this.itemDetails.rmsCode
        this.form.ggremCode = this.itemDetails.ggremCode
        this.form.supplierCode = this.itemDetails.supplierCode
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    },
    async saveEdition () {
      this.commands.submitState = 'WAIT'
      const payload = {
        id: this.itemDetails._id,
        isSuspended: this.form.isSuspended,
        isPreferred: this.form.isPreferred,
        rmsCode: this.form.rmsCode,
        ggremCode: this.form.ggremCode,
        supplierCode: this.form.supplierCode
      }
      try {
        this.$store.dispatch('Stock/SAVE_ITEM_EDITION', payload)
        this.$toasted.success('Atualização salva com sucesso!')
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$emit('confirmed-edit')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/stock/components/edit-item/EditItem.vue